<app-page-shell [breadcrumb]="breadcrumb" width="wide">
  <header class="mx-auto max-w-4xl pt-16 text-center md:pt-24">
    <p class="eyebrow">{{ 'pages.services.hero.eyebrow' | transloco }}</p>
    <h1 class="mt-4 font-display text-4xl font-bold leading-[1.05] text-ink md:text-6xl">
      {{ 'pages.services.hero.titlePrefix' | transloco }}
      <em class="not-italic text-primary">{{ 'pages.services.hero.titleAccent' | transloco }}</em>
    </h1>
    <p class="mx-auto mt-6 max-w-2xl text-base leading-relaxed text-muted-foreground md:text-lg">
      {{ 'pages.services.hero.description' | transloco }}
    </p>
  </header>

  <nav
    [attr.aria-label]="'pages.services.navigation.ariaLabel' | transloco"
    class="sticky top-16 z-30 -mx-6 mb-12 mt-16 border-y border-border/60 bg-background/85 backdrop-blur"
  >
    <ol class="hidden items-stretch gap-1 overflow-x-auto px-6 py-2.5 md:flex">
      @for (item of sectionNavItems; track item.id; let index = $index) {
        <li class="shrink-0">
          <a
            [href]="'#' + item.id"
            (click)="scrollToSection(item.id, $event)"
            class="group inline-flex items-center gap-2 rounded-full px-3.5 py-1.5 text-[13px] transition-colors"
            [class]="
              activeSection() === item.id
                ? 'bg-primary/10 text-primary'
                : 'text-muted-foreground hover:bg-muted/60 hover:text-foreground'
            "
          >
            <span
              class="font-display text-[11px] tabular-nums tracking-wider"
              [class]="activeSection() === item.id ? 'text-primary' : 'text-foreground/40'"
            >
              {{ formatIndex(index) }}
            </span>
            <span class="font-medium">{{ item.labelKey | transloco }}</span>
          </a>
        </li>
      }
    </ol>

    <div class="px-4 py-2 md:hidden">
      <label for="servicos-nav" class="sr-only">
        {{ 'pages.services.navigation.selectLabel' | transloco }}
      </label>
      <select
        id="servicos-nav"
        [value]="activeSection()"
        (change)="selectSection($event)"
        class="w-full rounded-md border border-border bg-background px-3 py-2 text-sm text-foreground"
      >
        @for (item of sectionNavItems; track item.id; let index = $index) {
          <option [value]="item.id">
            {{ formatIndex(index) }} — {{ item.labelKey | transloco }}
          </option>
        }
      </select>
    </div>
  </nav>

  <div class="space-y-28 md:space-y-32">
    <section id="servicos" class="scroll-mt-32">
      <header class="mb-2">
        <p class="eyebrow">{{ 'pages.services.services.eyebrow' | transloco }}</p>
      </header>

      <div class="relative mt-8">
        @for (service of services; track service.titleKey; let index = $index) {
          <div
            class="sticky"
            [style.top]="'calc(6rem + ' + index * 1.25 + 'rem)'"
            [style.z-index]="index + 1"
          >
            <article
              class="mb-8 overflow-hidden rounded-3xl border border-border bg-card p-8 shadow-sm transition-shadow hover:shadow-elevated md:p-12"
            >
              <div class="flex items-start justify-between gap-6">
                <p class="eyebrow">
                  {{ formatIndex(index) }} · {{ service.kickerKey | transloco }}
                </p>
                <span
                  aria-hidden="true"
                  class="font-display text-5xl font-semibold leading-none text-primary/15 tabular-nums md:text-6xl"
                >
                  {{ formatIndex(index) }}
                </span>
              </div>
              <h2
                class="mt-4 font-display text-2xl font-semibold leading-tight tracking-[-0.015em] text-foreground md:text-3xl"
              >
                {{ service.titleKey | transloco }}
              </h2>
              <p
                class="mt-5 max-w-[60ch] text-justify text-[15px] leading-relaxed text-muted-foreground md:text-base"
              >
                {{ service.bodyKey | transloco }}
              </p>
            </article>
          </div>
        }
      </div>
    </section>

    <!--
    <section id="morfologia" class="scroll-mt-32">
      <header class="mb-2">
        <p class="eyebrow">{{ 'pages.services.morphology.eyebrow' | transloco }}</p>
        <h2
          class="mt-3 font-display text-2xl font-semibold tracking-tight text-foreground md:text-3xl"
        >
          {{ 'pages.services.morphology.title' | transloco }}
        </h2>
        <p
          class="mt-4 max-w-[68ch] text-justify text-base leading-relaxed text-muted-foreground md:text-lg"
        >
          {{ 'pages.services.morphology.description' | transloco }}
        </p>
      </header>

      <ol class="mt-8 border-t border-border">
        @for (characteristic of characteristics; track characteristic.titleKey) {
          <li
            class="grid grid-cols-1 gap-x-6 border-b border-border py-8 md:grid-cols-[260px_1fr] md:gap-x-10 md:py-10"
          >
            <div>
              <h3
                class="font-display text-xl font-semibold leading-tight tracking-[-0.015em] text-foreground md:text-2xl"
              >
                {{ characteristic.titleKey | transloco }}
              </h3>
              <p
                class="mt-2 text-justify text-[14px] font-medium italic leading-snug text-primary md:text-[15px]"
              >
                {{ characteristic.shortKey | transloco }}
              </p>
            </div>
            <p
              class="mt-4 max-w-[58ch] text-justify text-[15px] leading-relaxed text-muted-foreground md:mt-0"
            >
              {{ characteristic.descriptionKey | transloco }}
            </p>
          </li>
        }
      </ol>
    </section>
    -->

    <section id="escada" class="scroll-mt-32">
      <header class="mb-2">
        <p class="eyebrow">{{ 'pages.services.analytics.eyebrow' | transloco }}</p>
        <h2
          class="mt-3 font-display text-2xl font-semibold tracking-tight text-foreground md:text-3xl"
        >
          {{ 'pages.services.analytics.title' | transloco }}
        </h2>
        <p
          class="mt-4 max-w-[68ch] text-justify text-base leading-relaxed text-muted-foreground md:text-lg"
        >
          {{ 'pages.services.analytics.description' | transloco }}
        </p>
      </header>

      <div class="relative isolate mt-8">
        <div
          aria-hidden="true"
          class="pointer-events-none absolute inset-0 -z-10 overflow-hidden rounded-3xl"
        >
          <div
            class="absolute -left-10 -top-16 h-72 w-72 rounded-full bg-primary/15 blur-3xl"
          ></div>
          <div
            class="absolute -right-16 top-1/3 h-80 w-80 rounded-full bg-secondary/15 blur-3xl"
          ></div>
          <div
            class="absolute -bottom-20 left-1/3 h-72 w-72 rounded-full bg-accent/15 blur-3xl"
          ></div>
        </div>

        <ol
          class="relative list-none"
          [attr.aria-label]="'pages.services.analytics.ariaLabel' | transloco"
        >
          @for (
            model of analyticsModels;
            track model.titleKey;
            let index = $index;
            let last = $last
          ) {
            <li>
              <article
                class="relative grid grid-cols-1 gap-6 rounded-2xl border border-border bg-card p-6 md:grid-cols-12 md:gap-10 md:p-8 lg:p-10"
              >
                <div class="flex flex-col gap-2 md:col-span-4">
                  <div class="flex items-center gap-3">
                    <span
                      class="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-primary/10 text-xs font-bold text-primary tabular-nums"
                    >
                      {{ formatIndex(index) }}
                    </span>
                    <h3
                      class="font-display text-2xl font-semibold tracking-tight text-foreground md:text-3xl"
                    >
                      {{ model.shortKey | transloco }}
                    </h3>
                  </div>
                  <p class="eyebrow mt-1">{{ model.titleKey | transloco }}</p>
                </div>

                <div class="md:col-span-8 md:pt-1">
                  <div
                    class="mb-4 inline-flex items-center gap-2.5 rounded-full border border-primary/20 bg-primary/5 px-4 py-1.5"
                  >
                    <span aria-hidden="true" class="size-1.5 rounded-full bg-primary/50"></span>
                    <span
                      class="text-[11px] font-semibold uppercase tracking-[0.18em] text-primary/80"
                    >
                      {{ model.questionKey | transloco }}
                    </span>
                  </div>
                  <p
                    class="max-w-[60ch] text-justify text-[15px] leading-relaxed text-muted-foreground md:text-base"
                  >
                    {{ model.descriptionKey | transloco }}
                  </p>
                </div>

                @if (!last) {
                  <span
                    aria-hidden="true"
                    class="absolute -bottom-8 left-4 hidden h-8 w-px bg-linear-to-b from-primary/40 to-transparent md:block"
                  ></span>
                }
              </article>

              @if (!last) {
                <div class="h-6 md:h-8"></div>
              }
            </li>
          }
        </ol>
      </div>
    </section>

    <section id="aprofundar" class="scroll-mt-32 border-t border-border pt-12">
      <p class="eyebrow">{{ 'pages.services.document.eyebrow' | transloco }}</p>
      <div class="flex flex-col items-start gap-6 md:flex-row md:items-center md:justify-between">
        <div class="max-w-xl">
          <h2
            class="mt-3 font-display text-2xl font-semibold tracking-tight text-foreground md:text-3xl"
          >
            {{ 'pages.services.document.titlePrefix' | transloco }}
            <em class="italic text-primary">{{
              'pages.services.document.titleAccent' | transloco
            }}</em>
          </h2>
          <p
            class="mt-3 text-justify text-[15px] leading-relaxed text-muted-foreground md:text-base"
          >
            {{ 'pages.services.document.description' | transloco }}
          </p>
        </div>
        <!-- <a [href]="documentHref" class="btn-pill btn-pill--primary group text-center">
          <svg
            aria-hidden="true"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
            class="h-4 w-4 shrink-0"
          >
            <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
            <path d="M14 2v6h6" />
            <path d="M16 13H8" />
            <path d="M16 17H8" />
          </svg>
          {{ 'pages.services.document.cta' | transloco }}
          <svg
            aria-hidden="true"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
            class="h-4 w-4 shrink-0 transition group-hover:translate-x-0.5"
          >
            <path d="M5 12h14" />
            <path d="m12 5 7 7-7 7" />
          </svg>
        </a>  -->
      </div>
    </section>
  </div>
</app-page-shell>
